import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ReviewData } from "../../../models/ReviewData";
import useFacilityReviews from "../RecentReviewsSection/hooks/useFacilityReviews";
import UnRepliedReviewItem from "../UnRepliedReviewItem";

import "./styles.scss";
export interface IModalUnRepliedReviewsProps {
  locationId: string;
  onClose: () => void;
}

export const ModalUnRepliedReviews: React.FunctionComponent<
  IModalUnRepliedReviewsProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.modalUnRepliedReviews.${key}`);
  const { onClose, locationId } = props;

  const now = dayjs();
  const {
    reviews: unRepliedReviewList,
    isLoading,
    refetch,
  } = useFacilityReviews({
    locationId,
    periodFromDate: dayjs(now).subtract(60, "days").format("YYYY-MM-DD"),
    periodToDate: dayjs(now).format("YYYY-MM-DD"),
    isReplied: 0,
    sort: "review_date",
    order: "desc",
    limit: 1000,
    offset: 0,
    seek_total_count: true,
  });

  const renderUnRepliedReviews = () => {
    if (isLoading) {
      return <div className="loading">{t("loading")}</div>;
    }

    if (!unRepliedReviewList || unRepliedReviewList?.length === 0) {
      return <div className="no-comment">{t("noCommentNeedReply")}</div>;
    }

    return unRepliedReviewList.map((review: ReviewData) => (
      <UnRepliedReviewItem key={review.id} review={review} refetch={refetch} />
    ));
  };

  return (
    <div className="modal modal-default modal-unreplied-reviews">
      <div className="modal-mains">
        <div className="btn-close" onClick={onClose}></div>
        <b className="title">{t("listOfNotReplied")}</b>
        <div className="review-container">{renderUnRepliedReviews()}</div>
        <div className="bottom-btns">
          <div className="btn btn-border" onClick={onClose}>
            {t("back")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalUnRepliedReviews;
